import JobLoadMoreContainer from "../../../components/job/other/JobLoadMore";

const JobLoadMore = () => {
  return <JobLoadMoreContainer />;
};

export default JobLoadMore;
